import { render, staticRenderFns } from "./TaskStartup.vue?vue&type=template&id=cace3104&scoped=true"
import script from "./TaskStartup.vue?vue&type=script&lang=js"
export * from "./TaskStartup.vue?vue&type=script&lang=js"
import style0 from "./TaskStartup.vue?vue&type=style&index=0&id=cace3104&prod&lang=scss&scoped=true"
import style1 from "./TaskStartup.vue?vue&type=style&index=1&id=cace3104&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cace3104",
  null
  
)

export default component.exports